import React from 'react';
import {
  Wallet, Scale, RotateCcw, Mail, Palette, Code2, Globe2, BellRing,
  DatabaseBackup, TrendingUp, PanelBottom, Files, ArrowRightLeft,
} from 'lucide-react';
import SettingsPage from '../Settings';
import LiveCasinoControl from '../LiveCasinoControl';
import SportsControlPanel from '../SportsControlPanel';
import FooterManagement from '../FooterManagement';
import FooterPages from '../FooterPages';
import SiteAddresses from '../SiteAddresses';
import EntryDomains from '../EntryDomains';
import MergedTabsPage from './MergedTabsPage';
import SportsProviders from './SportsProviders';
import '../gameControl.css';

/*
 * Menünün bölünmüş ya da birleştirilmiş sayfaları: aynı ekranların işe göre
 * ayrılmış hâli. İzinleri lib/navigation.js'teki menü maddesinden okunur;
 * kaldırılan eski adresler oradaki `LEGACY_REDIRECTS` ile buraya taşınır.
 *
 * Ayar sayfalarında `key` şarttır: hepsi aynı bileşendir ve anahtarsız
 * geçişte bir sayfanın formu (kaydedilmemiş değişikliği dahil) ötekine
 * taşınırdı.
 */
const settingsPage = (id, props) => <SettingsPage key={id} {...props} />;

const OddsCashout = () => (
  <div className="gc">
    <header className="gc-head">
      <span className="gc-head-icon"><TrendingUp size={22} /></span>
      <div className="gc-head-text">
        <h1>Oran &amp; Cashout</h1>
        <p>Spor bölümünün anahtarı, oran kaynakları, marjlar, cashout, özel oranlar ve sonuç girişi.</p>
      </div>
    </header>
    <SportsControlPanel view="odds" />
  </div>
);

export const V2_ROUTES = [
  {
    path: 'odeme-saglayicilari',
    element: settingsPage('payments', {
      onlyTabs: ['finance'],
      financePart: 'providers',
      title: 'Ödeme Sağlayıcıları',
      desc: 'Ödeme sağlayıcılarının bağlantı bilgileri, limitleri ve bildirim adresleri.',
      icon: Wallet,
    }),
  },
  {
    path: 'cekim-kurallari',
    element: settingsPage('withdraw-rules', {
      onlyTabs: ['finance'],
      financePart: 'rules',
      title: 'Çekim Kuralları',
      desc: 'Genel çekim alt/üst sınırı ve üyenin aynı anda kaç bekleyen çekimi olabileceği.',
      icon: Scale,
    }),
  },
  { path: 'oyun-servisleri', element: <LiveCasinoControl key="services" lockedSection="services" /> },
  { path: 'oyun-ayarlari', element: <LiveCasinoControl key="system" lockedSection="system" /> },
  { path: 'spor-saglayicilari', element: <SportsProviders /> },
  { path: 'oran-cashout', element: <OddsCashout /> },
  {
    path: 'kayip-bonusu',
    element: settingsPage('cashback', {
      onlyTabs: ['cashback'],
      title: 'Kayıp Bonusu',
      desc: 'Kayıp iadesinin hesaplama modeli, oranı, dönemi ve çevrim şartı.',
      icon: RotateCcw,
    }),
  },
  {
    path: 'toplu-mail',
    element: settingsPage('mail', {
      onlyTabs: ['mail'],
      title: 'Toplu Mail',
      desc: 'Üye segmentine toplu e-posta gönderimi. Giden posta sunucusu İletişim Kanalları’ndadır.',
      icon: Mail,
    }),
  },
  {
    path: 'tema-marka',
    element: settingsPage('design', {
      onlyTabs: ['design', 'branding'],
      title: 'Tema & Marka',
      desc: 'Site şeması, tema renkleri, logo ve sekme simgesi.',
      icon: Palette,
    }),
  },
  {
    path: 'ozel-kod',
    element: settingsPage('customcode', {
      onlyTabs: ['customcode'],
      title: 'Özel Kod',
      desc: 'Oyuncu portalına eklenen header, body ve footer kodları. Yönetim panelinde çalışmazlar.',
      icon: Code2,
    }),
  },
  {
    path: 'site-ayarlari',
    element: settingsPage('site', {
      onlyTabs: ['general', 'social'],
      title: 'Site Ayarları',
      desc: 'Site adı, iletişim bilgileri, kayıt kuralları ve sosyal medya adresleri.',
      icon: Globe2,
    }),
  },
  {
    path: 'iletisim-kanallari',
    element: settingsPage('channels', {
      onlyTabs: ['livechat', 'telegram', 'otp', 'smtp'],
      title: 'İletişim Kanalları',
      desc: 'Canlı destek, Telegram bildirimleri, SMS doğrulama ve giden posta sunucusu.',
      icon: BellRing,
    }),
  },
  {
    path: 'yedekleme',
    element: settingsPage('backup', {
      onlyTabs: ['backup'],
      title: 'Yedekleme',
      desc: 'Günlük yedeğin saati, Cloudflare R2 uzak yedeği, anlık yedek indirme ve geri yükleme.',
      icon: DatabaseBackup,
    }),
  },
  {
    path: 'footer-yonetimi',
    element: (
      <MergedTabsPage
        label="Footer bölümleri"
        tabs={[
          { id: 'menu', label: 'Menü ve Bantlar', icon: PanelBottom, component: FooterManagement, permission: 'content.read' },
          { id: 'sayfalar', label: 'Sayfalar', icon: Files, component: FooterPages, permission: 'content.read' },
        ]}
      />
    ),
  },
  {
    path: 'alan-adlari',
    element: (
      <MergedTabsPage
        label="Alan adı bölümleri"
        tabs={[
          { id: 'sabit', label: 'Sabit Adresler', icon: Globe2, component: SiteAddresses, permission: 'admin.manage' },
          { id: 'giris', label: 'Giriş Adresleri', icon: ArrowRightLeft, component: EntryDomains, permission: 'admin.manage' },
        ]}
      />
    ),
  },
];
